import { addMethod, setLocale, string } from 'yup';
import { fr } from 'yup-locales';

export default defineNuxtPlugin({
  parallel: false,
  setup: () => {
    setLocale({
      ...fr,
      mixed: {
        ...fr.mixed,
        required: 'Le champ "${label}" est requis',
      },
    });

    addMethod(string, 'zipCode', function () {
      return this.matches(/^\d{5}$/, "Le code postal n'est pas valide")
    });
  },
});
